
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import { AxiosResponse } from 'axios';
    import { SweetAlertResult } from 'sweetalert2';
    import Patient from '@/types/Patient';
    import PatientSearch from './PatientSearch.vue';
    import api from '@/services/Api';
    import { PatientSearchFilter, PatientSearchItem } from '@/components/Impfverwaltung/Patient/PatientSearch.vue';
    import { confirmSwal } from '@/helper/swals';
    import { VAutocomplete } from '@/types/Components';
    import { UebertragenPatientPayload } from '@/store/patient';

    @Component({
        components: {
            PatientSearch,
        },
        computed: {
            ...mapState('patient', ['loaders', 'patientData']),
        },
        methods: {
            ...mapActions('patient', ['uebertragenPatient']),
        },
    })
    export default class PatientUebertragung extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            search: Vue & { $refs: { search: VAutocomplete } };
        };

        public patient = new Patient();
        public searchResult: PatientSearchItem[] = [];
        public patientData!: Patient;
        public uebertragenPatient!: (payload: UebertragenPatientPayload) => void;

        public filter: PatientSearchFilter = {
            patnr: 0,
        };

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.filter.patnr = this.patientData.patnr ?? 0;
                this.patient = new Patient();
                this.searchResult = [];
            }
        }

        public onSelectPatient(selection: PatientSearchItem | null): void {
            if (selection) {
                api.post('ivs/patienten/load', { patnr: selection.id })
                    .then((response: AxiosResponse) => {
                        this.patient = new Patient(response.data.body);
                        this.$refs.search.$refs.search.blur();
                    })
                    .catch(console.error);
            }
        }

        public onClickUebertragen(): void {
            confirmSwal('Übertragung',
                        `Alle Daten vom aktuellen Patienten ${this.patientData.name} werden an Patienten ${this.patient.name}
                übertragen. Sind Sie sicher?`, 'Übertragen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.uebertragenPatient({
                            uebertraeger: this.patientData.patnr as number,
                            uebernehmer: this.patient.patnr as number,
                        });
                    }
                });
        }
    }
